import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate, MESSAGES } from './../../common/helper/common-imports.component.js';
import{  RowsPerPageSelector, SearchTable, DataTable,customDataTableStyles } from './../../common/helper/table-imports.js';
import TicketService from '../../../services/tickets-service.js';
import { ticketsColumns } from './tickets-col.component.js'

const Tickets = () => { 
  const [loading, setLoading] = useState(false);
  const [tickets , setTicketsData] = useState([]);
  const [dataTableKey, setDataTableKey] = useState(0);
  const navigate = useNavigate();
  const userData = useSelector(state => state.authReducer);

  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [pageNo, setPageNo] = useState(0);
  const [totalRows, setTotalRows] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [status,setStatus] = useState('');
  const [ticketCount , setTicketCount] = useState([]);

  const [activeStatus, setActiveStatus] = useState('PENDING');


  const [isDropdownVisible, setDropdownVisible] = useState(false);

  const paginationComponentOptions = { 
    noRowsPerPage :true
  }
  const [filterData, setFilterData] = useState({
    end_date: '',
    start_date: '',
    merchantID: '',
    agentID: '',
    paymentType: '',
    status: ''
  });
  const [columns, setColumns] =  useState(ticketsColumns(userData));


const filterTickets = ( status) => {
    setActiveStatus(status.status);
    listTickets(0,rowsPerPage,status.status);
}
const createTicket = () => {
    navigate(`/create-ticket`)
}

  const listTickets = (pageNumber, rowsPage, status) => {
    setStatus(status)
    let tickets =  TicketService.getTicketHistory(pageNumber, rowsPage, status)
    setLoading(true);
    tickets.then(response => {
      console.log(response.data.data)
      const records = response.data.data.list
      setTotalRows(response.data.data.total_records)
      setTicketsData(records)
      setTicketCount(response.data.data.additional_params.status_wise_totals)
      setLoading(false);
    })
    .catch(error => {
        console.log(error)
      setLoading(false);
      try {
        const errorMessage = error.response.data
        toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
      } catch (e){
        toast.error( MESSAGES.SERVER_ERROR)
      }
    });
  }
    const sortedTicketCount = [...ticketCount].sort((a, b) => {
        if (a.status === "PENDING") return -1;
        if (b.status === "PENDING") return 1;
        return 0;
    });
  useEffect(() => {

    listTickets(0,25,"PENDING");
    
    document.body.style.backgroundImage = '';

    document.body.style.backgroundColor = '#f0f6fa';
    return () => {
      document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
    };
}, []);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };
  const escapeRegExp = (string) => {
    return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
  };

  function getStatusText(statusCode) {
    switch (statusCode) {
      case 'I':
        return 'Initiated';
      case 'A':
        return 'Completed';
      case 'AA':
        return 'Agent Accepted';
      case 'RA':
        return 'Raised';
      case 'RM':
        return 'Merchnat Raised';
      case 'F':
        return 'Failed';
      case 'R':
        return 'Rejected';
      case 'MC':
        return 'Cancelled';
        case 'E':
        return 'Expired';
      default:
        return ''; // or handle unknown status codes
    }
  }
  
  const filteredData = tickets && tickets.filter((row) => {
    // Check if any value in the row matches the search term
    return Object.values(row).some((value) => {
      // If value is a status code, convert it to full status text
      if (value === row.status) {
        const statusText = getStatusText(row.status); // Get full status text
        return statusText.toLowerCase().includes(searchTerm.toLowerCase());
      }
      // Otherwise, directly test against the value
      return new RegExp(escapeRegExp(searchTerm), 'i').test(value);
    });
  });

  const handleRowsPerPageChange = (value) => {
    setRowsPerPage(Number(value));
    setDataTableKey(prevKey => prevKey + 1);
    listTickets(pageNo, value,status)
  };
   
   
      const handlePageChange = page => {
        let pageNumber = page - 1;
        setPageNo(pageNumber)
        listTickets(pageNumber, rowsPerPage,status);
  };
  
   useEffect(() => {
            if (filteredData?.length) {
              const element = document.getElementsByClassName("sc-bHCmUC");
              const childElement = element[0].children;
              for (let i = 0; i < childElement?.length; i++) {
                const ele = childElement[i].id.split("-")[1];
                if (Number(ele) % 2 === 0) {
                  childElement[i].classList.add("even-transaction-table");

                } else {
                  childElement[i].classList.add("odd-transaction-table");

                }
              }
            }
          }, [filteredData]);
     
    return(

      <>
        <LoaderOverlay loading={loading} />
   
        <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
        <h4 className="updatename updatename1" style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>Tickets History</h4>
        
        <div className="container" style={{backgroundColor: 'white'}}>
        <div className="ticket-status-container ">
        {sortedTicketCount.map((status, index) => (
                <div
                    key={index}
                    className={`ticket-status ${activeStatus === status.status ? 'active' : ''}`}

                    onClick={() => filterTickets(status)}>
                    <span className="label-ticket">{status.status} ({status.count})</span>
                    {/* <span className="count">{status.count}</span> */}
                </div>
            ))}
        </div>
          <nav>
            <div className="nav nav-tabs" id="nav-tab" role="tablist">
              <button className="nav-link tbbtn active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true" >Tickets {activeStatus.charAt(0).toUpperCase() + activeStatus.slice(1).toLowerCase()}</button>
              {/* <button className="nav-link tbbtn" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false"  onClick={() => resetSearch('Complete')} tabIndex={-1}>Complete Transaction</button> */}
            </div>
          </nav>
          <div className="filterBtn">
                        
                  <SearchTable searchTerm={searchTerm} handleSearchChange={handleSearchChange}/>
                        <div className="dt-buttons ui-buttonset"><a className="dt-button ui-button ui-state-default ui-button-text-only btn btn-success ddfg" tabIndex={0} aria-controls="examplemgm"><span className="ui-button-text" onClick={createTicket}>Create Ticket</span></a></div>
                  </div>
                  <RowsPerPageSelector rowsPerPage={rowsPerPage} onRowsPerPageChange={handleRowsPerPageChange} />
          <div className="tab-content" id="nav-tabContent" style={{paddingTop: '15px', paddingBottom: '15px'}}>
            <div className="tab-pane fade active show" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
              <main>
                <div className style={{paddingBottom: '30px'}}>
                  <div className style={{backgroundColor: 'white'}}>
                    <div className="tab-content" id="nav-tabContent" style={{}}>
                      <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
          <div className="col-md-12" style={{textAlign: 'right'}}>
                    
      </div>
                       
                        <div id="examplemgmwallet_wrapper" className="dataTables_wrapper dt-jqueryui no-footer">

                        <DataTable key={dataTableKey}
                            columns={columns}
                              data={filteredData}
                              pagination
                              paginationComponentOptions={paginationComponentOptions} 
                              paginationPerPage={rowsPerPage} 
                              paginationServer
                              paginationTotalRows={totalRows}
                              onChangePage={handlePageChange}
                              customStyles={customDataTableStyles}

                        />
                        
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </main>
            </div>
     
          </div>
        </div>
      </div>
      </>
    )
}

function mapStateToProps(state) {
    const userData = state.authReducer.user;
    return { userData };
  }
export default withAuth(connect(mapStateToProps)(Tickets));